import { MutationTree } from 'vuex';
import { State }        from '@/views/dynamic-tables/store/dynamic-tables.state.store';
import { ReportsList }  from '@/views/dynamic-tables/dynamic-tables.types';

const mutations: MutationTree<State> = {
  setTableData(state: State, data: ReportsList[]): void {
    state.dynamicTables = data;
  },
  setDataLoaded(state: State, status: boolean): void {
    state.dataLoaded = status;
  },
};

export default mutations;
